import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GetGooglePlaceService {

    address:                      any = "";
    private messageSource =    new BehaviorSubject<any>(this.address);
    $address = this.messageSource.asObservable();
    addressAbv:                      any= "";
    private messageSourceAbv =    new BehaviorSubject<any>(this.addressAbv);
    $addressAbv = this.messageSourceAbv.asObservable();
    mailingPOBoxAddress;
    private mailingPOBoxAddContainer;
    $mailingPOBoxAddress;

    constructor() {
      this.mailingPOBoxAddress = null;
      this.mailingPOBoxAddContainer =    new BehaviorSubject<any>(this.mailingPOBoxAddress);
      this.$mailingPOBoxAddress= this.mailingPOBoxAddContainer.asObservable();
    }
  
    updateAddress(address: any) {
      this.messageSource.next(address);
    }

    updateAddressAbv(addressAbv: any) {
      this.messageSourceAbv.next(addressAbv);
    }

    //To update mailing/PO Box address
    updateMailingPOBoxAdd(mailingPOBoxAddress: any) {
      this.mailingPOBoxAddContainer.next(mailingPOBoxAddress);
    }

}